<template>
  <!-- TODO: this should ideally use the Popover + Anchor positioning API, but anchor positioning is still wonky in browser support -->
  <div
    v-show="open"
    id="signup-dialog"
    ref="dialogRef"
    class="signup-popover-wrapper"
    role="dialog"
    aria-modal="false"
    :aria-label="$t('newsletter.aria-label')"
  >
    <div class="signup-popover">
      <button type="button" class="close-btn" :aria-label="$t('newsletter.close')" @click="$emit('close')">
        <BaseIcon icon="close" class="size-26" />
      </button>
      <SignupForm direction="row" input-color="subtle" />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  open: boolean;
}>();

const emit = defineEmits<{
  close: [];
}>();

const dialogRef = ref<HTMLElement>();

// Close on Escape while open; focus return to the trigger is handled by its owner.
onKeyStroke("Escape", () => {
  if (props.open) emit("close");
});

// Move focus to the email field when the popover opens so keyboard/screen-reader users land inside it.
// `flush: "post"` runs the callback after the v-show DOM update is applied, so the field is visible
// and focusable without a manual nextTick.
watch(
  () => props.open,
  (isOpen) => {
    if (!isOpen) return;
    dialogRef.value?.querySelector<HTMLElement>("input")?.focus();
  },
  { flush: "post" }
);
</script>

<style lang="scss" scoped>
.signup-popover-wrapper {
  position: absolute;
  top: 100%;
  left: 50%;
  translate: -50% 0;
  margin: 0;
  margin-top: 1rem;
  border-radius: $border-radius;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e1e1e1;
  padding: 0;
  width: 446px;
  background-color: $light-100;
  z-index: 10;
}

.signup-popover {
  position: relative;
  padding: 1rem;
}

// Keep the form heading clear of the absolutely-positioned close button so the
// title text doesn't run underneath it.
.signup-popover :deep(h4) {
  padding-right: 2rem;
}

.close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  cursor: pointer;
  color: $dark-50;
}
</style>
